import React, {useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import { ScrollRestoration } from "react-router-dom";
import SEO from "components/SEO/SEO";

//CSS
import styles from  "./lagomera.module.less";

const ExperienceLaGomera = () => {

  const [t,i18n] = useTranslation("pages");
  const [actualImg, setActualImg] = useState(0);
  const images =[
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/slide/1.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/slide/2.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/slide/3.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/slide/4.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/slide/5.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/slide/6.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/slide/7.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/slide/8.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/slide/9.jpg",
    process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/slide/10.jpg"
  ]

  function handleChangeImg(direcction){
    if (direcction === "right"){
      if (actualImg < images.length-1) setActualImg(actualImg+1);
      else setActualImg(0);
    }else if (direcction === "left"){
      if (actualImg > 0) setActualImg(actualImg-1);
      else setActualImg(images.length-1);
    }
  }

  useEffect(()=>{
    const interval = setInterval(() => {
      handleChangeImg('right');
    }, 5000);
    return () => clearInterval(interval);
  },[actualImg])

  let imgsHTML=null;

  if(Array.isArray(images) && images.length){
    imgsHTML = images.map((img,index)=>{
      const imgid="img-"+index;
      const show = actualImg === index ? styles.slideImg + ' ' + styles.fadeIn :  styles.slideImg + ' ' + styles.fadeOut;
      return (
        <div key={index} className={show} id={imgid}>
          <img key={index} src={img} alt={"Slide " + index}/>
        </div>
      );
    });
  }

  return(
    <>
      <SEO title={t('experiences.lagomera.SEOTitulo')} description={t('experiences.lagomera.SEODescipcion')} name='Viajes Teide' type='experience' />

      <div className={styles.lagomera}>

          <div className={styles.fotoIndexContent}>
              <img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/foto-index_" + i18n.language + ".jpg"} alt={t('experiences.lagomera.Roque de Agando')} />
          </div>

          <div className={styles.introText}>
            <div className={styles.title}>{t('experiences.lagomera.La Gomera')}</div>
            <div className={styles.text}>
              {t('experiences.lagomera.Es una de las islas más pequeña del archipielago canario y desde 2012, es reserva de la biosfera. Poseen un dialecto propio trasmitido por el silvido, uno de los bosque de Laurisilvas continuos más extensos de europa y fue un lugar clave para la historia de la conquista de América. Ven y conoce La Gomera con nosotros')}
            </div>
          </div>

          <div className={styles.slide}>
            <div className={styles.slideContent}>{imgsHTML}</div>
            <div className={styles.imgsButtonsLeft} onClick={() => handleChangeImg("left")}></div>
            <div className={styles.imgsButtonsRight} onClick={() => handleChangeImg("right")}></div>
          </div>

          <div className={styles.infoText}>
            <div className={styles.title}>{t('experiences.lagomera.Lo más interesante de La Gomera')}</div>
            <div className={styles.cols}>

              <div className={styles.col}><img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/interesante1.jpg"} /></div>

              <div className={styles.col}>
                <div className={styles.title}>{t('experiences.lagomera.El Silvo Gomero')}</div>
                <div className={styles.text}>
                  <p>{t('experiences.lagomera.El silbo gomero es un lenguaje silbado practicado por algunos habitantes. Este dialecto nace de la necesidad de comunicarse con otras personas, sin tener que desplazarse por la difícil topografía de la isla')}.</p>
                  <p>{t('experiences.lagomera.Este dialecto fue desarrollado por los antiguos aborígenes. Pero tras la conquista en el siglo XVI, los canarios adaptaron el dialecto al castellano salvado, perdiendo con el tiempo la adaptación original usando como base las palabras aborígenes')}.</p>
                  <p>{t('experiences.lagomera.Con el inicio del siglo pasado, y el nacimiento de las nuevas tecnologías el silbido empezó a desaparecer en el uso cotidiano de los habitantes. Y para evitar esto, en 1.999 se declara el silbo gomero como patrimonio etnográfico de Canarias. Y en 2009 se inscribe por la Unesco en la Lista representativa del Patrimonio Cultural Inmaterial de la Humanidad. Gracias en buena parte a la labor realizada por el gobierno canario, hoy en día se impartes clases de silbo Gomero en las escuelas como una asignatura más')}.</p>
                  <p>{t('experiences.lagomera.Según los estudios el lenguaje silbado emplea seis sonidos, dos de ellos denominados como vocales y los otros cuatro como consonantes, y se pueden expresar más de 4.000 palabras')}.</p>
                </div>
              </div>

              <div className={styles.col}>
                <div className={styles.title}>{t('La Laurisilva')}</div>
                <div className={styles.text}>
                  <p>{t('experiences.lagomera.La laurisilva canaria es un tipo de bosque subtropical presente en algunas de las islas Canarias. Está muy emparentado con otras formaciones boscosas comunes en el resto del espacio biogeográfico denominado la Macaronesia. Está compuesta por especies arbóreas de la familia de las lauráceas, que junto al Fayal-Brezal compone el denominado monteverde. Se encuentra entre los 600 y 1.500 m de altitud. Su ecosistemas se mantiene gracias a la bruma de los alisios, carentes de heladas, con precipitaciones de 500 a 1100 mm y que gracias a ella, pueden mantener una temperatura media anual de entre 15 y 19 ºC')}.</p>
                  <p>{t('experiences.lagomera.Este tipo de bosques nació hace más de 20 millones de años, por una amplia zona de la cuenca del Mediterráneo. Durante la glaciación Fueron desplazandas hacia regiones más templadas del sur, donde las condiciones eran más propicias para su supervivencia, asentándose de este modo en el norte de África y en los archipiélagos macaronésicos. Al concluir las glaciaciones, comenzó la extensión de los desiertos en África septentrional, por lo que este tipo de bosque quedó reducido a aquellas áreas, que actúan como bordes entre la zona templada y la intertropical (la Macaronesia). A lo largo de millones de años, los bosques de La Gomera han sufrido muy pocas transformaciones evolutivas, por lo que es una reliquia viviente de las formaciones vegetales que cubrían gran parte de Europa durante el Terciario')}.</p>
                </div>
              </div>

              <div className={styles.col}><img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/interesante2.jpg"} /></div>

              <div className={styles.col}><img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/interesante3.jpg"} /></div>

              <div className={styles.col}>
                <div className={styles.title}>{t('experiences.lagomera.Historia de La Gomera')}</div>
                <div className={styles.text}>
                  <p>{t('experiences.lagomera.De esta isla con forma circular, siempre se habla y se conoce su magnifica vegetacion, belleza y de su extraño dialecto (el silbo gomero). Pero ¿que pasa con sus historia?')}.</p>
                  <p>{t('experiences.lagomera.Sobre la procedencia de su nombre no hay nada claro, hay varias teorías pero ninguna oficial. Se dice que puede ser procedente de “Comer”, nieto de Noé. Pero la teoría más avalada, es la idea de que los antiguos aborígenes, que se creen que procedían de la tribu de los Bereber (norte de África), fueron los que pusieron el nombre “Gumera” a la isla. Y ya en 1350, en un mapa y debido a que su creador castellanizó los nombres de las islas, aparece por primera vez como La Gomera')}.</p>
                  <p>{t('experiences.lagomera.Al comenzar la conquista, la isla se encontraba dividida en 4 cantones: Mulagua, Hipalan, Orone y Agana, identificándose estos territorios con los grandes valles de Hermigua, San Sebastián, Valle Gran Rey y Vallehermoso, respectivamente')}.</p>
                  <p>{t('experiences.lagomera.La isla es también conocida como la isla colombina. Este apodo viene dado por Cristobal Colón, ya que La Gomera fue el último lugar que piso antes de que iniciara el viaje a las Indias. Hoy en día, el lugar donde descanso y toma fuerzas antes de su partida se llama la Casa de Colón')}.</p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.video}>
            <iframe src="https://player.vimeo.com/video/163392660?color=009933&title=0&byline=0&portrait=0" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
            <script src="https://player.vimeo.com/api/player.js"></script>
          </div>

          <div className={styles.tips}>
            <div className={styles.tip}>
              <img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/1-tip.png"} />
              <div className={styles.text}>{t('experiences.lagomera.La Gomera es una de las islas del archipiélago que mejor ha conservado tradiciones de los habitantes prehispánicos, como las loceras de barro')}</div>
            </div>
            <div className={styles.tip}>
              <img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/2-tip.png"} />
              <div className={styles.text}>{t('experiences.lagomera.Tienes una fiesta lustral, Bajada de la Virgen de Guadalupe. La sacan de su ermita y durante 2 meses está dando vueltas por la isla')}</div>
            </div>
            <div className={styles.tip}>
              <img src={process.env.REACT_APP_COMMONS_STORAGE_URL + "images/experiences/la-gomera/3-tip.png"} />
              <div className={styles.text}>{t('experiences.lagomera.Hasta los años 60, la economía dependía de la agricultura y ganadería. Hoy en día más del 80% viven del turismo')}</div>
            </div>
          </div>

      </div>
      <ScrollRestoration />
    </>
  );
}

export default ExperienceLaGomera;